/**
 * Actions Components - Context-switching action widgets for Copilot panel
 *
 * Each component provides entity-specific quick actions:
 * - ProjectActions: Create RFQ, view timeline, export
 * - RFQActions: Send to vendors, compare quotes, add products
 * - VendorActions: Request catalog, contact, order history
 * - ProductActions: Add to cart, request quote, find alternatives
 * - VendorResponseActions: Convert to PO, contact vendor, request revision
 *
 * @layer presentation
 * @arch_domain copilot
 */

export { ProjectActions } from './project-actions';
export { RFQActions } from './rfq-actions';
export { VendorActions } from './vendor-actions';
export { ProductActions } from './product-actions';
export { VendorResponseActions } from './vendor-response-actions';
